import { enqueueSnackbar, DownloadFile } from 'actions';

import {
	GetSTTMAlgorithmDataRequest,
	GetWeekRequest,
	// GetHTMLStringRequest,

} from '../requests/STTMAlgorithmRequestsGeneric';

export const GET_STTM_ALGORITHM_DATA = 'GET_STTM_ALGORITHM_DATA';
export const GET_WEEK = 'GET_WEEK';
// export const GET_HTML_STRING = 'GET_HTML_STRING';

const onGetSTTMAlgorithmData = (value) => ({
	type: GET_STTM_ALGORITHM_DATA,
	data: value
});

const onGetWeek = (value) => ({
	type: GET_WEEK,
	week: value
});

// const onGetHTMLString = (value) => ({
// 	type: GET_HTML_STRING,
// 	data: value
// });

export const GetSTTMAlgorithmData = (userId, role) => async (dispatch) => {
	await GetSTTMAlgorithmDataRequest(userId, role).then(response => {
		dispatch(onGetSTTMAlgorithmData(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetWeek = (userId, role) => async (dispatch) => {
	await GetWeekRequest(userId, role).then(response => {
		dispatch(onGetWeek(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// export const GetHTMLString = (id, cell, userId) => async (dispatch) => {
// 	await GetHTMLStringRequest(id, cell, userId).then(response => {
// 		dispatch(onGetHTMLString(response.data));
// 	}).catch((error) => {
// 		if (error) {
// 			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
// 		}
// 	});
// };
